// source: accounts/protos/user_dto.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */


var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.accounts.protos.AvatarCode', null, global);
goog.exportSymbol('proto.accounts.protos.UserDTO', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accounts.protos.UserDTO = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accounts.protos.UserDTO, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accounts.protos.UserDTO.displayName = 'proto.accounts.protos.UserDTO';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accounts.protos.UserDTO.prototype.toObject = function(opt_includeInstance) {
  return proto.accounts.protos.UserDTO.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accounts.protos.UserDTO} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.UserDTO.toObject = function(includeInstance, msg) {
  var f, obj = {
    email: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    unverifiedEmail: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
    emailVerifiedAt: (f = msg.getEmailVerifiedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    country: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
    mobileNumberPrefix: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
    mobileNumber: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
    avatarCode: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f,
    introCompleted: (f = jspb.Message.getBooleanField(msg, 9)) == null ? undefined : f,
    pushNotifications: (f = jspb.Message.getBooleanField(msg, 10)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accounts.protos.UserDTO}
 */
proto.accounts.protos.UserDTO.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accounts.protos.UserDTO;
  return proto.accounts.protos.UserDTO.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accounts.protos.UserDTO} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accounts.protos.UserDTO}
 */
proto.accounts.protos.UserDTO.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnverifiedEmail(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEmailVerifiedAt(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobileNumberPrefix(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobileNumber(value);
      break;
    case 8:
      var value = /** @type {!proto.accounts.protos.AvatarCode} */ (reader.readEnum());
      msg.setAvatarCode(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIntroCompleted(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPushNotifications(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accounts.protos.UserDTO.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accounts.protos.UserDTO.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accounts.protos.UserDTO} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.UserDTO.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEmailVerifiedAt();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
  f = /** @type {!proto.accounts.protos.AvatarCode} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeBool(
      9,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeBool(
      10,
      f
    );
  }
};


/**
 * required string email = 2;
 * @return {string}
 */
proto.accounts.protos.UserDTO.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.UserDTO} returns this
 */
proto.accounts.protos.UserDTO.prototype.setEmail = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UserDTO} returns this
 */
proto.accounts.protos.UserDTO.prototype.clearEmail = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UserDTO.prototype.hasEmail = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string unverified_email = 3;
 * @return {string}
 */
proto.accounts.protos.UserDTO.prototype.getUnverifiedEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.UserDTO} returns this
 */
proto.accounts.protos.UserDTO.prototype.setUnverifiedEmail = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UserDTO} returns this
 */
proto.accounts.protos.UserDTO.prototype.clearUnverifiedEmail = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UserDTO.prototype.hasUnverifiedEmail = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp email_verified_at = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.accounts.protos.UserDTO.prototype.getEmailVerifiedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.accounts.protos.UserDTO} returns this
*/
proto.accounts.protos.UserDTO.prototype.setEmailVerifiedAt = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accounts.protos.UserDTO} returns this
 */
proto.accounts.protos.UserDTO.prototype.clearEmailVerifiedAt = function() {
  return this.setEmailVerifiedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UserDTO.prototype.hasEmailVerifiedAt = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string country = 5;
 * @return {string}
 */
proto.accounts.protos.UserDTO.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.UserDTO} returns this
 */
proto.accounts.protos.UserDTO.prototype.setCountry = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UserDTO} returns this
 */
proto.accounts.protos.UserDTO.prototype.clearCountry = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UserDTO.prototype.hasCountry = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string mobile_number_prefix = 6;
 * @return {string}
 */
proto.accounts.protos.UserDTO.prototype.getMobileNumberPrefix = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.UserDTO} returns this
 */
proto.accounts.protos.UserDTO.prototype.setMobileNumberPrefix = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UserDTO} returns this
 */
proto.accounts.protos.UserDTO.prototype.clearMobileNumberPrefix = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UserDTO.prototype.hasMobileNumberPrefix = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string mobile_number = 7;
 * @return {string}
 */
proto.accounts.protos.UserDTO.prototype.getMobileNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.UserDTO} returns this
 */
proto.accounts.protos.UserDTO.prototype.setMobileNumber = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UserDTO} returns this
 */
proto.accounts.protos.UserDTO.prototype.clearMobileNumber = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UserDTO.prototype.hasMobileNumber = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional AvatarCode avatar_code = 8;
 * @return {!proto.accounts.protos.AvatarCode}
 */
proto.accounts.protos.UserDTO.prototype.getAvatarCode = function() {
  return /** @type {!proto.accounts.protos.AvatarCode} */ (jspb.Message.getFieldWithDefault(this, 8, 1));
};


/**
 * @param {!proto.accounts.protos.AvatarCode} value
 * @return {!proto.accounts.protos.UserDTO} returns this
 */
proto.accounts.protos.UserDTO.prototype.setAvatarCode = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UserDTO} returns this
 */
proto.accounts.protos.UserDTO.prototype.clearAvatarCode = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UserDTO.prototype.hasAvatarCode = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional bool intro_completed = 9;
 * @return {boolean}
 */
proto.accounts.protos.UserDTO.prototype.getIntroCompleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UserDTO} returns this
 */
proto.accounts.protos.UserDTO.prototype.setIntroCompleted = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UserDTO} returns this
 */
proto.accounts.protos.UserDTO.prototype.clearIntroCompleted = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UserDTO.prototype.hasIntroCompleted = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional bool push_notifications = 10;
 * @return {boolean}
 */
proto.accounts.protos.UserDTO.prototype.getPushNotifications = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UserDTO} returns this
 */
proto.accounts.protos.UserDTO.prototype.setPushNotifications = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UserDTO} returns this
 */
proto.accounts.protos.UserDTO.prototype.clearPushNotifications = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UserDTO.prototype.hasPushNotifications = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * @enum {number}
 */
proto.accounts.protos.AvatarCode = {
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FOUR: 4,
  FIVE: 5,
  SIX: 6
};

goog.object.extend(exports, proto.accounts.protos);
